import { render, staticRenderFns } from "./ClientNoteList.vue?vue&type=template&id=0f04791c&"
import script from "./ClientNoteList.vue?vue&type=script&lang=js&"
export * from "./ClientNoteList.vue?vue&type=script&lang=js&"
import style0 from "./ClientNoteList.vue?vue&type=style&index=0&id=0f04791c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports